import { Step1ValueModel, Step4ValueModel, Step5ValueModel } from './types'
import {
    validateOrganisationNumber,
    OrganisationType,
    validateContactPerson,
    validateToC,
} from '../Validation'
import { FormErrorType } from "@sharedComponents/PantaForm/types";
import { validateRequired } from "@sharedComponents/PantaForm/utils";
import i18n from "@apps/Shared/translation/i18n";

export const validateStep1 = async (
    stepValues: Step1ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateRequired(
        stepValues.organizationNumber,
        'organizationNumber',
        i18n.t('error.emptyOrgnr'),
        currentErrors
    )

    if (stepValues.organizationNumber) {
        const validationResult = await validateOrganisationNumber(
            OrganisationType.Customer,
            stepValues.organizationNumber,
            errors,
            true,
            false
        )
        return validationResult
    }

    return { errors: errors }
}

export const validateStep4 = async (
    stepValues: Step4ValueModel,
    contactPersonFormErrors: FormErrorType[],
    reportPersonFormErrors: FormErrorType[],
    hideReportPersonForm?: boolean
) => {
    contactPersonFormErrors = validateContactPerson(
        stepValues.contactPerson,
        contactPersonFormErrors,
        true
    )
    reportPersonFormErrors = validateContactPerson(
        stepValues.reportPerson,
        reportPersonFormErrors,
        !hideReportPersonForm
    )

    return [contactPersonFormErrors, reportPersonFormErrors]
}

export const validateStep5 = async (
    stepValues: Step5ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateToC(stepValues.terms, currentErrors)

    return errors
}